<template>
  <div :class="{ 
    'position-relative d-flex align-items-center': true, 
    'thumb-filled': !empty,
    'thumb-empty': empty,
    }" 
    :style="`width: ${width + borderWidth * 2}px; height: ${height + borderWidth * 2}px`"
    @click="clickable ? onClick() : null">
    <img v-if="img_src" :src="img_src" :width="width" :height="height" alt="Thumbnail" />
    <section v-if="clickable" class="d-flex flex-column">
      <v-icon color="#033e8c">mdi-plus</v-icon>
      <b>{{ $t('common.addFile') }}</b>
    </section>
    <v-progress-linear
      class="overlay"
      background-opacity="0"
      v-if="isUploading"
      :value="percent"
      color="#33ee33"
    >
    </v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "Thumbnail",
  props: {
    img_src: {
      type: String,
      default: null
    },
    width: {
      type: [String, Number],
      default: 84
    },
    height: {
      type: [String, Number],
      default: 84
    },
    empty: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Number,
      default: 0
    },
    isUploading: {
      type: Boolean,
      default: false,
    },
    borderWidth: {
      type: Number,
      default: 3
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.thumb-filled {
  border: 3px solid #033e8c;
}

.thumb-empty {
  border: 3px dotted #979797;
}

b {
  display: inline-block;
  width: 84px;
  max-width: 84px;
  color: #033e8c;
  font-size: 15px;
  word-break: break-word;
  overflow-wrap: break-word;
  overflow: hidden;
  hyphens: auto;
}
.overlay {
  position: absolute;
  width: 100%;
  z-index: 2;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>